//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Calculates without saving of result.
 * @param dto Recipe to calculate.
 * @return Dto with result.
 */
export function calculateOnTheFly(dto: Types.CalculateOnTheFlyDto, config?: AxiosRequestConfig | undefined): Promise<Types.RecipeCalculationBaseDto> {
    let url_ = getBaseUrl() + "/api/RecipeCalculation/on-the-fly";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCalculateOnTheFlyDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCalculateOnTheFly,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCalculateOnTheFly?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCalculateOnTheFly(_response);
    });
}

function processCalculateOnTheFly(response: AxiosResponse): Promise<Types.RecipeCalculationBaseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRecipeCalculationBaseDto(resultData200);
        return Promise.resolve<Types.RecipeCalculationBaseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RecipeCalculationBaseDto>(null as any);
}

/**
 * Suggests ranked recipes for a target formula using the requesting user's materials and the
public material library.
 * @param dto Target formula and material availability.
 */
export function suggestPalettes(dto: Types.SuggestPalettesDto, config?: AxiosRequestConfig | undefined): Promise<Types.SuggestPalettesResult> {
    let url_ = getBaseUrl() + "/api/RecipeCalculation/suggest-palettes";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeSuggestPalettesDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSuggestPalettes,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSuggestPalettes?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSuggestPalettes(_response);
    });
}

function processSuggestPalettes(response: AxiosResponse): Promise<Types.SuggestPalettesResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initSuggestPalettesResult(resultData200);
        return Promise.resolve<Types.SuggestPalettesResult>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SuggestPalettesResult>(null as any);
}

/**
 * Returns the oxide-to-role mapping used by the calculation engine.
Cached by the frontend to drive the WebAssembly calculator.
 * @return List of oxide-to-role mappings.
 */
export function getOxideRoles(config?: AxiosRequestConfig | undefined): Promise<Types.OxideRoleDto[]> {
    let url_ = getBaseUrl() + "/api/RecipeCalculation/oxide-roles";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetOxideRoles,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetOxideRoles?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetOxideRoles(_response);
    });
}

function processGetOxideRoles(response: AxiosResponse): Promise<Types.OxideRoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initOxideRoleDto(item)
              );
            }
        return Promise.resolve<Types.OxideRoleDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.OxideRoleDto[]>(null as any);
}

/**
 * Reduces recipe to 100 without saving of result.
 * @param recipe Recipe to calculate.
 * @return Dto with result.
 */
export function reduceRecipeTo100(recipe: Types.IngredientForCalculationDto[], config?: AxiosRequestConfig | undefined): Promise<Types.IngredientDto[]> {
    let url_ = getBaseUrl() + "/api/RecipeCalculation/reduce-to-100";
      url_ = url_.replace(/[?&]$/, "");

    recipe = recipe.map(item => Types.prepareSerializeIngredientForCalculationDto(item))
    const content_ = JSON.stringify(recipe);

    let options_: AxiosRequestConfig = {
        ..._requestConfigReduceRecipeTo100,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigReduceRecipeTo100?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processReduceRecipeTo100(_response);
    });
}

function processReduceRecipeTo100(response: AxiosResponse): Promise<Types.IngredientDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initIngredientDto(item)
              );
            }
        return Promise.resolve<Types.IngredientDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.IngredientDto[]>(null as any);
}

/**
 * Creates a new recipe calculation in the system.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param dto Dto with data for creation.
 * @return Dto with recipe calculation data.
 */
export function create(recipeId: number, dto: Types.CreateUpdateRecipeCalculationDto, config?: AxiosRequestConfig | undefined): Promise<Types.RecipeCalculationDto> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateUpdateRecipeCalculationDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreate(_response);
    });
}

function processCreate(response: AxiosResponse): Promise<Types.RecipeCalculationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRecipeCalculationDto(resultData200);
        return Promise.resolve<Types.RecipeCalculationDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RecipeCalculationDto>(null as any);
}

/**
 * Updates the recipe calculation in the system.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation.
 * @param dto Dto with data for creation.
 * @return Dto with recipe calculation data.
 */
export function update(recipeId: number, calculationId: number, dto: Types.CreateUpdateRecipeCalculationDto, config?: AxiosRequestConfig | undefined): Promise<Types.RecipeCalculationDto> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
    if (calculationId === undefined || calculationId === null)
      throw new Error("The parameter 'calculationId' must be defined.");
    url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateUpdateRecipeCalculationDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdate,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigUpdate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdate(_response);
    });
}

function processUpdate(response: AxiosResponse): Promise<Types.RecipeCalculationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRecipeCalculationDto(resultData200);
        return Promise.resolve<Types.RecipeCalculationDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RecipeCalculationDto>(null as any);
}

/**
 * Removes the recipe calculation from the system.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation.
 */
export function removeRecipeCalculation(recipeId: number, calculationId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
    if (calculationId === undefined || calculationId === null)
      throw new Error("The parameter 'calculationId' must be defined.");
    url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveRecipeCalculation,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemoveRecipeCalculation?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveRecipeCalculation(_response);
    });
}

function processRemoveRecipeCalculation(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Gets the latest version of recipe calculations.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 */
export function getAll(recipeId: number, config?: AxiosRequestConfig | undefined): Promise<Types.RecipeCalculationDto[]> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/all";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAll,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetAll?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAll(_response);
    });
}

function processGetAll(response: AxiosResponse): Promise<Types.RecipeCalculationDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initRecipeCalculationDto(item)
              );
            }
        return Promise.resolve<Types.RecipeCalculationDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RecipeCalculationDto[]>(null as any);
}

/**
 * Gets a specific version of the recipe calculation.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation.
 * @param versionId Version of calculation to return.
 * @return Dto with result.
 */
export function getVersion(recipeId: number, calculationId: number, versionId: number, config?: AxiosRequestConfig | undefined): Promise<Types.CalculationHistoryRecordDto> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}/version/{versionId}";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
    if (calculationId === undefined || calculationId === null)
      throw new Error("The parameter 'calculationId' must be defined.");
    url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
    if (versionId === undefined || versionId === null)
      throw new Error("The parameter 'versionId' must be defined.");
    url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetVersion,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetVersion?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetVersion(_response);
    });
}

function processGetVersion(response: AxiosResponse): Promise<Types.CalculationHistoryRecordDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initCalculationHistoryRecordDto(resultData200);
        return Promise.resolve<Types.CalculationHistoryRecordDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CalculationHistoryRecordDto>(null as any);
}

/**
 * Calculates recipe for batch.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation for batch.
 * @param amount (optional) Final amount of glaze after mixing.
 * @param includeAdditions (optional) Shows whether additional ingredients should be included into amount.
 * @return Dto with result.
 */
export function calculateBatch(recipeId: number, calculationId: number, amount?: number | undefined, includeAdditions?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.RecipeBatchDto> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}/calculate-batch?";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
    if (calculationId === undefined || calculationId === null)
      throw new Error("The parameter 'calculationId' must be defined.");
    url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
    if (amount === null)
        throw new Error("The parameter 'amount' cannot be null.");
    else if (amount !== undefined)
        url_ += "amount=" + encodeURIComponent("" + amount) + "&";
    if (includeAdditions === null)
        throw new Error("The parameter 'includeAdditions' cannot be null.");
    else if (includeAdditions !== undefined)
        url_ += "includeAdditions=" + encodeURIComponent("" + includeAdditions) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCalculateBatch,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigCalculateBatch?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCalculateBatch(_response);
    });
}

function processCalculateBatch(response: AxiosResponse): Promise<Types.RecipeBatchDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRecipeBatchDto(resultData200);
        return Promise.resolve<Types.RecipeBatchDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RecipeBatchDto>(null as any);
}

/**
 * Moves the recipe calculation to another recipe.
 * @param recipeId Id of the recipe, where new calculation is located.
 * @param calculationId Id of the recipe calculation.
 * @param targetRecipeId (optional) Recipe Id where the recipe should be moved.
 * @param shouldBeCopied (optional) True if recipe calculator should be copied.
 */
export function move(recipeId: number, calculationId: number, targetRecipeId?: number | undefined, shouldBeCopied?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}/move?";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
    if (calculationId === undefined || calculationId === null)
      throw new Error("The parameter 'calculationId' must be defined.");
    url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
    if (targetRecipeId === null)
        throw new Error("The parameter 'targetRecipeId' cannot be null.");
    else if (targetRecipeId !== undefined)
        url_ += "targetRecipeId=" + encodeURIComponent("" + targetRecipeId) + "&";
    if (shouldBeCopied === null)
        throw new Error("The parameter 'shouldBeCopied' cannot be null.");
    else if (shouldBeCopied !== undefined)
        url_ += "shouldBeCopied=" + encodeURIComponent("" + shouldBeCopied) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigMove,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigMove?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processMove(_response);
    });
}

function processMove(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Applies a user-defined display order to the recipe's calculations.
 * @param recipeId Id of the recipe to which the recipe calculations belong to.
 * @param dto Ids of the calculations in the desired display order.
 */
export function reorder(recipeId: number, dto: Types.ReorderRecipeCalculationsDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/reorder";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeReorderRecipeCalculationsDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigReorder,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigReorder?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processReorder(_response);
    });
}

function processReorder(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Sets (or clears) the cosmetic display color of a recipe calculation.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation.
 * @param dto Dto with the color to apply (or null to reset).
 */
export function setColor(recipeId: number, calculationId: number, dto: Types.SetCalculationColorDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}/color";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
    if (calculationId === undefined || calculationId === null)
      throw new Error("The parameter 'calculationId' must be defined.");
    url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeSetCalculationColorDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSetColor,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigSetColor?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSetColor(_response);
    });
}

function processSetColor(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Gets data for recipe calculation printing.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation for batch.
 * @param amount (optional) Final amount of glaze after mixing.
 * @param includeAdditions (optional) Shows whether additional ingredients should be included into amount.
 * @return Dto with result.
 */
export function getPrintData(recipeId: number, calculationId: number, amount?: number | undefined, includeAdditions?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PrintRecipeCalculationDto> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}/print?";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
    if (calculationId === undefined || calculationId === null)
      throw new Error("The parameter 'calculationId' must be defined.");
    url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
    if (amount === null)
        throw new Error("The parameter 'amount' cannot be null.");
    else if (amount !== undefined)
        url_ += "amount=" + encodeURIComponent("" + amount) + "&";
    if (includeAdditions === null)
        throw new Error("The parameter 'includeAdditions' cannot be null.");
    else if (includeAdditions !== undefined)
        url_ += "includeAdditions=" + encodeURIComponent("" + includeAdditions) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPrintData,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetPrintData?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPrintData(_response);
    });
}

function processGetPrintData(response: AxiosResponse): Promise<Types.PrintRecipeCalculationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPrintRecipeCalculationDto(resultData200);
        return Promise.resolve<Types.PrintRecipeCalculationDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PrintRecipeCalculationDto>(null as any);
}

/**
 * Gets data for printing multiple recipe calculations in one call.
 * @param recipeId Id of the recipe to which the recipe calculations belong to.
 * @param calculationIds (optional) Ids of the recipe calculations to print.
 * @param amount (optional) Final amount of glaze after mixing.
 * @param includeAdditions (optional) Shows whether additional ingredients should be included into amount.
 * @return List of dtos with results, one per requested calculation.
 */
export function getPrintDataBatch(recipeId: number, calculationIds?: number[] | undefined, amount?: number | undefined, includeAdditions?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PrintRecipeCalculationDto[]> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/print-batch?";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
    if (calculationIds === null)
        throw new Error("The parameter 'calculationIds' cannot be null.");
    else if (calculationIds !== undefined)
        calculationIds && calculationIds.forEach(item => { url_ += "calculationIds=" + encodeURIComponent("" + item) + "&"; });
    if (amount === null)
        throw new Error("The parameter 'amount' cannot be null.");
    else if (amount !== undefined)
        url_ += "amount=" + encodeURIComponent("" + amount) + "&";
    if (includeAdditions === null)
        throw new Error("The parameter 'includeAdditions' cannot be null.");
    else if (includeAdditions !== undefined)
        url_ += "includeAdditions=" + encodeURIComponent("" + includeAdditions) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPrintDataBatch,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetPrintDataBatch?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPrintDataBatch(_response);
    });
}

function processGetPrintDataBatch(response: AxiosResponse): Promise<Types.PrintRecipeCalculationDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initPrintRecipeCalculationDto(item)
              );
            }
        return Promise.resolve<Types.PrintRecipeCalculationDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PrintRecipeCalculationDto[]>(null as any);
}

/**
 * Calculates point in a linear blend and creates a recipe calculation with result in the recipe.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param dto Dto with necessary data for blend calculation.
 */
export function createFromLinearBlend(recipeId: number, dto: Types.CalculateLinearBlend, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/linear-blend";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCalculateLinearBlend(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateFromLinearBlend,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateFromLinearBlend?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateFromLinearBlend(_response);
    });
}

function processCreateFromLinearBlend(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Calculates point in a triangle blend and creates a recipe calculation with result in the recipe.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param dto Dto with necessary data for blend calculation.
 */
export function createFromTriangleBlend(recipeId: number, dto: Types.CalculateTriangleBlendDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/triangle-blend";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCalculateTriangleBlendDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateFromTriangleBlend,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateFromTriangleBlend?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateFromTriangleBlend(_response);
    });
}

function processCreateFromTriangleBlend(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Calculates point in a rectangle blend and creates a recipe calculation with result in the recipe.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param dto Dto with necessary data for blend calculation.
 */
export function createFromRectangleBlend(recipeId: number, dto: Types.CalculateRectangleBlendDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/rectangle-blend";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCalculateRectangleBlendDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateFromRectangleBlend,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateFromRectangleBlend?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateFromRectangleBlend(_response);
    });
}

function processCreateFromRectangleBlend(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigCalculateOnTheFly: Partial<AxiosRequestConfig> | null;
export function getCalculateOnTheFlyRequestConfig() {
  return _requestConfigCalculateOnTheFly;
}
export function setCalculateOnTheFlyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCalculateOnTheFly = value;
}
export function patchCalculateOnTheFlyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCalculateOnTheFly = patch(_requestConfigCalculateOnTheFly ?? {});
}

let _requestConfigSuggestPalettes: Partial<AxiosRequestConfig> | null;
export function getSuggestPalettesRequestConfig() {
  return _requestConfigSuggestPalettes;
}
export function setSuggestPalettesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSuggestPalettes = value;
}
export function patchSuggestPalettesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSuggestPalettes = patch(_requestConfigSuggestPalettes ?? {});
}

let _requestConfigGetOxideRoles: Partial<AxiosRequestConfig> | null;
export function getGetOxideRolesRequestConfig() {
  return _requestConfigGetOxideRoles;
}
export function setGetOxideRolesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetOxideRoles = value;
}
export function patchGetOxideRolesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetOxideRoles = patch(_requestConfigGetOxideRoles ?? {});
}

let _requestConfigReduceRecipeTo100: Partial<AxiosRequestConfig> | null;
export function getReduceRecipeTo100RequestConfig() {
  return _requestConfigReduceRecipeTo100;
}
export function setReduceRecipeTo100RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigReduceRecipeTo100 = value;
}
export function patchReduceRecipeTo100RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigReduceRecipeTo100 = patch(_requestConfigReduceRecipeTo100 ?? {});
}

let _requestConfigCreate: Partial<AxiosRequestConfig> | null;
export function getCreateRequestConfig() {
  return _requestConfigCreate;
}
export function setCreateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreate = value;
}
export function patchCreateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreate = patch(_requestConfigCreate ?? {});
}

let _requestConfigUpdate: Partial<AxiosRequestConfig> | null;
export function getUpdateRequestConfig() {
  return _requestConfigUpdate;
}
export function setUpdateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdate = value;
}
export function patchUpdateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdate = patch(_requestConfigUpdate ?? {});
}

let _requestConfigRemoveRecipeCalculation: Partial<AxiosRequestConfig> | null;
export function getRemoveRecipeCalculationRequestConfig() {
  return _requestConfigRemoveRecipeCalculation;
}
export function setRemoveRecipeCalculationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveRecipeCalculation = value;
}
export function patchRemoveRecipeCalculationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveRecipeCalculation = patch(_requestConfigRemoveRecipeCalculation ?? {});
}

let _requestConfigGetAll: Partial<AxiosRequestConfig> | null;
export function getGetAllRequestConfig() {
  return _requestConfigGetAll;
}
export function setGetAllRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAll = value;
}
export function patchGetAllRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAll = patch(_requestConfigGetAll ?? {});
}

let _requestConfigGetVersion: Partial<AxiosRequestConfig> | null;
export function getGetVersionRequestConfig() {
  return _requestConfigGetVersion;
}
export function setGetVersionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetVersion = value;
}
export function patchGetVersionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetVersion = patch(_requestConfigGetVersion ?? {});
}

let _requestConfigCalculateBatch: Partial<AxiosRequestConfig> | null;
export function getCalculateBatchRequestConfig() {
  return _requestConfigCalculateBatch;
}
export function setCalculateBatchRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCalculateBatch = value;
}
export function patchCalculateBatchRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCalculateBatch = patch(_requestConfigCalculateBatch ?? {});
}

let _requestConfigMove: Partial<AxiosRequestConfig> | null;
export function getMoveRequestConfig() {
  return _requestConfigMove;
}
export function setMoveRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigMove = value;
}
export function patchMoveRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigMove = patch(_requestConfigMove ?? {});
}

let _requestConfigReorder: Partial<AxiosRequestConfig> | null;
export function getReorderRequestConfig() {
  return _requestConfigReorder;
}
export function setReorderRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigReorder = value;
}
export function patchReorderRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigReorder = patch(_requestConfigReorder ?? {});
}

let _requestConfigSetColor: Partial<AxiosRequestConfig> | null;
export function getSetColorRequestConfig() {
  return _requestConfigSetColor;
}
export function setSetColorRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSetColor = value;
}
export function patchSetColorRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSetColor = patch(_requestConfigSetColor ?? {});
}

let _requestConfigGetPrintData: Partial<AxiosRequestConfig> | null;
export function getGetPrintDataRequestConfig() {
  return _requestConfigGetPrintData;
}
export function setGetPrintDataRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPrintData = value;
}
export function patchGetPrintDataRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPrintData = patch(_requestConfigGetPrintData ?? {});
}

let _requestConfigGetPrintDataBatch: Partial<AxiosRequestConfig> | null;
export function getGetPrintDataBatchRequestConfig() {
  return _requestConfigGetPrintDataBatch;
}
export function setGetPrintDataBatchRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPrintDataBatch = value;
}
export function patchGetPrintDataBatchRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPrintDataBatch = patch(_requestConfigGetPrintDataBatch ?? {});
}

let _requestConfigCreateFromLinearBlend: Partial<AxiosRequestConfig> | null;
export function getCreateFromLinearBlendRequestConfig() {
  return _requestConfigCreateFromLinearBlend;
}
export function setCreateFromLinearBlendRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateFromLinearBlend = value;
}
export function patchCreateFromLinearBlendRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateFromLinearBlend = patch(_requestConfigCreateFromLinearBlend ?? {});
}

let _requestConfigCreateFromTriangleBlend: Partial<AxiosRequestConfig> | null;
export function getCreateFromTriangleBlendRequestConfig() {
  return _requestConfigCreateFromTriangleBlend;
}
export function setCreateFromTriangleBlendRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateFromTriangleBlend = value;
}
export function patchCreateFromTriangleBlendRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateFromTriangleBlend = patch(_requestConfigCreateFromTriangleBlend ?? {});
}

let _requestConfigCreateFromRectangleBlend: Partial<AxiosRequestConfig> | null;
export function getCreateFromRectangleBlendRequestConfig() {
  return _requestConfigCreateFromRectangleBlend;
}
export function setCreateFromRectangleBlendRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateFromRectangleBlend = value;
}
export function patchCreateFromRectangleBlendRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateFromRectangleBlend = patch(_requestConfigCreateFromRectangleBlend ?? {});
}